module.exports = __webpack_public_path__ + "static/person_studying-96bd0c0b7d2dafad1eed08362b2d0264.png";